"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M12.7994 12.782L12.6004 13.579C12.4384 14.227 11.6994 14.54 11.1184 14.211C9.01545 13.021 7.25245 11.304 6.00245 9.24C5.69445 8.73 5.87045 8.065 6.40345 7.799L7.42345 7.288C7.76445 7.118 7.97945 6.771 7.97945 6.39V3.005C7.97945 2.45 7.52845 2 6.97445 2H3.00645C2.41745 2 1.96245 2.505 2.00245 3.093C2.54145 11.065 8.93545 17.459 16.9074 17.998C17.4954 18.038 18.0004 17.583 18.0004 16.994V13.026C18.0004 12.471 17.5504 12.021 16.9954 12.021H13.7734C13.3134 12.021 12.9104 12.336 12.7994 12.782Z",
    fill: "#727B7F"
  }));
};